import swipe from './swipe';
import { getVideoPlayer } from './videos';
import globals from './globals';

function isInViewport(slider) {
  const scrollTop =
    window.scrollY === undefined ? window.pageYOffset : window.scrollY;
  const windowHeight = window.innerHeight;
  const rect = slider.getBoundingClientRect();

  return (
    rect.top + rect.height + scrollTop > scrollTop &&
    rect.top + scrollTop < scrollTop + windowHeight
  );
}

function isSlideVideo(slide) {
  return slide.classList.contains('c-slider__slide--video');
}

function setSliderClasses(slider, currentSlide) {
  if (isSlideVideo(currentSlide)) {
    slider.classList.add('is-video');
  } else {
    slider.classList.remove('is-video');
  }
}

function setSlide(slider, slideIndex) {
  const slides = slider.querySelectorAll('.c-slider__slide');
  [].forEach.call(slides, (slide, index) => {
    slide.classList.remove('left');
    slide.classList.remove('right');
    slide.classList.add('no-transition');

    if (index < slideIndex) {
      slide.classList.add('left');
    } else if (index > slideIndex) {
      slide.classList.add('right');
    }
  });

  // eslint-disable-next-line
  slider.offsetHeight;

  [].forEach.call(slides, slide => {
    slide.classList.remove('no-transition');
  });

  setSliderClasses(slider, slides[slideIndex]);
  slider.setAttribute('data-current-slide', slideIndex);
}

function resetSlides(
  slider,
  slides,
  links,
  moveClass,
  currentSlideElement,
  nextSlideElement,
) {
  [].forEach.call(slides, (slide, slideIndex) => {
    if (slide !== currentSlideElement && slide !== nextSlideElement) {
      const link = links[slideIndex];
      slide.classList.add('no-transition');

      if (link !== undefined) {
        link.classList.add('no-transition');
      }

      // eslint-disable-next-line
      slider.offsetWidth;
      slide.classList.remove('left');
      slide.classList.remove('right');
      slide.classList.add(moveClass);

      if (link !== undefined) {
        link.classList.remove('left');
        link.classList.remove('right');
        link.classList.add(moveClass);
      }

      // eslint-disable-next-line
      slider.offsetWidth;
      slide.classList.remove('no-transition');

      if (link !== undefined) {
        link.classList.remove('no-transition');
      }
    }
  });
}

function prepareSliders() {
  const sliders = document.querySelectorAll('.c-slider');

  if (sliders.length < 1) {
    return;
  }

  [].forEach.call(sliders, (slider, sliderIndex) => {
    const slides = slider.querySelectorAll('.c-slider__slide');
    const links = slider.querySelectorAll('.c-slider__link');

    if (slides.length < 1) {
      return;
    }

    slider.setAttribute('data-current-slide', 0);
    let sliderTimeout = null;
    let animating = false;
    const autoplayTime = slider.hasAttribute('data-time')
      ? parseInt(slider.getAttribute('data-time'), 10)
      : 0;

    if (slider.classList.contains('c-slider--fullscreen')) {
      const closeSlider = slider.querySelector('.c-slider__close');

      if (closeSlider !== null) {
        closeSlider.addEventListener('click', event => {
          event.preventDefault();

          slider.classList.remove('active');
          globals.html.classList.remove('is-slider-fullscreen');
        });
      }
    }

    const changeSlide = (delta, source) => {
      const currentSlide = parseInt(
        slider.getAttribute('data-current-slide'),
        10,
      );
      let nextSlide = currentSlide + delta;
      let moveClass = '';
      let videoPlayer;

      if (nextSlide < 0) {
        nextSlide = slides.length - 1;
        moveClass = 'left';
      } else if (nextSlide >= slides.length) {
        nextSlide = 0;
        moveClass = 'right';
      }

      console.log(currentSlide, nextSlide, delta, moveClass);

      const currentSlideElement = slides[currentSlide];
      const nextSlideElement = slides[nextSlide];
      const currentSlideLink = links[currentSlide];
      const nextSlideLink = links[nextSlide];
      const videosTransition =
        isSlideVideo(currentSlideElement) && isSlideVideo(nextSlideElement);
      const moveDirection = nextSlide > currentSlide ? 'left' : 'right';

      if (
        animating ||
        (globals.html.classList.contains('is-slider-fullscreen') &&
          source === 'auto') ||
        !isInViewport(slider)
      ) {
        if (source === 'auto' && autoplayTime > 0) {
          sliderTimeout = setTimeout(() => {
            changeSlide(1, 'auto');
          }, autoplayTime);
        }
        return;
      }

      if (moveClass) {
        resetSlides(
          slider,
          slides,
          links,
          moveClass,
          currentSlideElement,
          nextSlideElement,
        );
      }

      currentSlideElement.classList.remove('left');
      currentSlideElement.classList.remove('right');
      currentSlideElement.classList.remove('no-transition');

      if (currentSlideLink !== undefined) {
        currentSlideLink.classList.remove('left');
        currentSlideLink.classList.remove('right');
        currentSlideLink.classList.remove('no-transition');
      }

      if (videosTransition) {
        currentSlideElement.classList.add('faded-out');

        nextSlideElement.classList.add('no-transition');
        // eslint-disable-next-line
        nextSlideElement.offsetWidth;
        nextSlideElement.classList.add('faded-out');

        setTimeout(() => {
          nextSlideElement.classList.remove('left');
          nextSlideElement.classList.remove('right');
          // eslint-disable-next-line
          nextSlideElement.offsetWidth;
          nextSlideElement.classList.remove('no-transition');
          nextSlideElement.classList.remove('faded-out');

          setTimeout(() => {
            currentSlideElement.classList.add('no-transition');
            // eslint-disable-next-line
            currentSlideElement.offsetWidth;
            currentSlideElement.classList.add(moveDirection);
            currentSlideElement.classList.remove('no-transition');
          }, 250);
        }, 250);
      } else {
        currentSlideElement.classList.add(moveDirection);

        if (currentSlideLink !== undefined) {
          currentSlideLink.classList.add(moveDirection);
        }

        nextSlideElement.classList.remove('left');
        nextSlideElement.classList.remove('right');
        nextSlideElement.classList.remove('no-transition');

        if (nextSlideLink !== undefined) {
          nextSlideLink.classList.remove('left');
          nextSlideLink.classList.remove('right');
          nextSlideLink.classList.remove('no-transition');
        }
      }

      if (isSlideVideo(currentSlideElement)) {
        videoPlayer = getVideoPlayer(currentSlideElement);
        if (videoPlayer !== undefined) {
          videoPlayer.pause().catch(error => {
            console.log(error.message);
          });
        }
      }

      if (isSlideVideo(nextSlideElement)) {
        videoPlayer = getVideoPlayer(nextSlideElement);
        if (videoPlayer !== undefined) {
          setTimeout(() => {
            videoPlayer.play().catch(error => {
              console.log(error.message);
            });
          }, 500);
        }
      }

      setSliderClasses(slider, nextSlideElement);

      if ((source === 'auto' || source === 'movie') && autoplayTime > 0) {
        sliderTimeout = setTimeout(() => {
          changeSlide(1, 'auto');
        }, autoplayTime);
      } else if (sliderTimeout !== null) {
        clearTimeout(sliderTimeout);
        sliderTimeout = null;
      }

      slider.setAttribute('data-current-slide', nextSlide);

      animating = true;

      setTimeout(() => {
        animating = false;
      }, 1000);
    };

    const navButtons = slider.querySelectorAll('.c-slider__arrow');

    [].forEach.call(navButtons, button => {
      button.addEventListener('click', event => {
        event.preventDefault();
        changeSlide(
          event.currentTarget.classList.contains('c-slider__arrow--previous')
            ? -1
            : 1,
        );
      });

      swipe(button, direction => {
        changeSlide(direction === 'left' ? 1 : -1);
      });
    });

    if (slides.length > 1) {
      document.addEventListener('keydown', event => {
        const e = event || window.event;

        if (
          !isInViewport(slider) ||
          ((document.activeElement !== null &&
            /INPUT|TEXTAREA/.test(document.activeElement.nodeName)) ||
            (slider.classList.contains('c-slider--fullscreen') &&
              !slider.classList.contains('active')))
        ) {
          return;
        }

        if (e.keyCode === 37) {
          changeSlide(-1);
        } else if (e.keyCode === 39) {
          changeSlide(1);
        }
      });
    }

    [].forEach.call(slides, (slide, slideIndex) => {
      swipe(slide, direction => {
        changeSlide(direction === 'left' ? 1 : -1);
      });

      const link = links[slideIndex];

      if (link !== undefined) {
        swipe(link, direction => {
          changeSlide(direction === 'left' ? 1 : -1);
        });
      }

      if (isSlideVideo(slide)) {
        const videoPlayer = getVideoPlayer(slide);

        if (videoPlayer !== undefined) {
          videoPlayer.on('ended', () => {
            if (sliderTimeout !== null) {
              changeSlide(1, 'movie');
            }
          });
        }
      }
    });

    if (
      slider.classList.contains('c-slider--hero') &&
      sliderIndex === 0 &&
      slides.length > 0
    ) {
      const firstSlideVideoPlayer = getVideoPlayer(slides[0]);
      if (firstSlideVideoPlayer !== undefined) {
        firstSlideVideoPlayer.on('loaded', () => {
          firstSlideVideoPlayer.play().catch(error => {
            console.log(error.message);
          });
        });
      }
    }

    if (slides.length > 1 && autoplayTime > 0) {
      sliderTimeout = setTimeout(() => {
        changeSlide(1, 'auto');
      }, autoplayTime);
    }

    setSliderClasses(slider, slides[0]);

    const fullscreenButton = slider.querySelector(
      '.c-slider__fullscreen[data-id]',
    );

    if (fullscreenButton !== null) {
      const fullscreenSlider = document.getElementById(
        fullscreenButton.getAttribute('data-id'),
      );

      if (fullscreenSlider !== null) {
        fullscreenButton.addEventListener('click', event => {
          event.preventDefault();
          fullscreenSlider.classList.add('active');
          globals.html.classList.add('is-slider-fullscreen');
          const slideIndex = parseInt(
            slider.getAttribute('data-current-slide'),
            10,
          );
          if (!Number.isNaN(slideIndex)) {
            setSlide(fullscreenSlider, slideIndex);
          }
        });

        swipe(fullscreenButton, direction => {
          changeSlide(direction === 'left' ? 1 : -1);
        });
      }
    }
  });
}

export { prepareSliders as default, setSlide };



// WEBPACK FOOTER //
// ./src/scripts/modules/sliders.js